<template>
	<div class="form-group row">
		<label :for="label" class="col-sm-3 col-form-label">{{formatTitle(label)}}</label>
		<div class="col-sm-9 text-center">
			<img class="mb-2 preview" :id="`${label}-preview`" :src="value" />
			<input type="file" class="form-control" :id="label" @change="changeImage($event)" />
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'label'
	],
	methods: { 
		formatTitle (input) {
			return input.replace('_',' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
		},
		changeImage( event ){
			var vm = this
			var canvas = document.createElement('canvas');
			var context = canvas.getContext("2d"); 
			context.imageSmoothingEnabled = true;
			var img = new Image();
			var files = event.target.files;
			var file = files[0];
			if(file.type.match('image.*')) {
				var reader = new FileReader();
				// Read in the image file as a data URL.
				reader.readAsDataURL(file);
				reader.onload = function(evt){
					if( evt.target.readyState == FileReader.DONE) {
						img.src = evt.target.result;
						img.onload = function(){
							var canvasCopy = document.createElement('canvas');
							var contextCopy = canvasCopy.getContext("2d");
							contextCopy.imageSmoothingEnabled = true;
							var ratio = 1;
							if(img.width > width)
								ratio = width / img.width;
							else if(img.height > height)
								ratio = height / img.height;
							var width = 150;
							var height = 300;

							if(img.width > width)
								ratio = width / img.width;
							else if(img.height > height)
								ratio = height / img.height;
							canvasCopy.width = img.width;
							canvasCopy.height = img.height;
							contextCopy.drawImage(img, 0, 0);

							canvas.width = img.width * ratio;
							canvas.height = img.height * ratio;
							context.fillStyle = "white";
							context.fillRect(0, 0, canvas.width, canvas.height);
							context.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);
							var dataURL = canvas.toDataURL('image/jpeg', 0.8);
							vm.$emit('input', dataURL)
						}
					}
				}    
			} else {
				alert("not an image");
			}
		},
	}
}
</script>

<style scoped>
img.preview {
	max-height: 150px;
}
</style>